<template>
  <div class="container">
    <div class="start"></div>
    <div class="end" v-if="false"></div>
    <div class="aside">
      <div class="aside_title">
        {{ title }}
      </div>
      <div class="aside_item">
        <div  
        @click="itemAction(item, index)" 
        class="asideItem"
        :class="{'asideItem_active': currentIndex == index}"
        v-for="(item, index) in items" 
        :key="index">
          <div class="circle"></div>
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftAside',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array, 
      default: []
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  methods: {

    // item点击事件
    itemAction(item, index) {
      this.$emit('itemAction', item,index);
    },

    // 设置当前选中的元素
    setCurrentIndex(index) {
      this.currentIndex = index
    }

  }
}
</script>

<style lang="scss" scoped>

.container {
  width: 361px;
  padding-top: 60px;
  border-right: 4px solid rgba(42, 69, 167, 0.2);
  position: relative;
  padding: 60px 20px 0 20px;

  .start {
    position: absolute;
    top: 0;
    right: -12px;
    width: 24px;
    height: 38px;
    background-color: #2A45A7;
  }

  .end {
    position: absolute;
    bottom: 0;
    right: -12px;
    width: 24px;
    height: 38px;
    background-color: #2A45A7;
  }

  .aside {
    position: sticky;
    top: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .aside_title {
      padding: 18px 46px;
      background-color: #E8EEFC;
      font-size: 20px;
      font-family: "SourceHanSansSC-Heavy-2";
      font-weight: 800;
      color: #2A45A7;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }

    .aside_item {
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      .asideItem {
        // margin-left: 20px;
        padding: 20px 0;
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: "SourceHanSansSC-Medium-2";
        font-weight: 500;
        color: rgba(24, 36, 93, 0.2);
        // white-space: pre-line; // 合并空白符序列，但保留换行符
        text-align: left;

        .circle {
          margin-right: 12px;
          border-radius: 6px;
          width: 12px;
          height: 12px;
          background-color: rgba(24, 36, 93, 0.2);
        }

        &:hover {
          cursor: pointer;
        }
      }

      .asideItem_active {
        color: #24262B;

        .circle {
          background-color: #E43363;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/homepage/childComps/LeftAside.vue